export type DakaiEquipmentLike = {
  solutionRovider?: string;
  deviceId?: string;
  displayname?: string;
  vendorId?: number;
  productId?: number;
};

export function isDakaiEquipment(
  eq: DakaiEquipmentLike | null | undefined
): boolean {
  if (!eq) return false;
  if (String(eq.solutionRovider ?? "") === "dakai") return true;
  const deviceId = String(eq.deviceId ?? "");
  if (deviceId === "v80" || deviceId === "v102") return true;
  const vid = Number(eq.vendorId);
  const pid = Number(eq.productId);
  return vid === 0x05ac && pid === 0x024f;
}

export type DakaiV102EquipmentLike = DakaiEquipmentLike & {
  keyboardType?: string;
};

/** V102（含 LOGO / 屏幕版），用于滚轮键等仅 V102 的能力 */
export function isDakaiV102Equipment(
  eq: DakaiV102EquipmentLike | null | undefined
): boolean {
  if (!eq || !isDakaiEquipment(eq)) return false;
  const deviceId = String(eq.deviceId ?? "").toLowerCase();
  if (deviceId === "v102") return true;
  const keyboardType = String(eq.keyboardType ?? "").toLowerCase();
  if (keyboardType === "v102") return true;
  const name = String(eq.displayname ?? "").toUpperCase();
  return name.includes("V102");
}
